
// ============================================
// Talk Masonry Helper
// ============================================
(function (window) {
    if (window.__TalkMasonryHelperInitialized) {
        return;
    }
    window.__TalkMasonryHelperInitialized = !0;

    var talkMasonry = {
        grid: null,
        wrapper: null,
        moreButton: null,
        instance: null,
        layoutHandler: null,
        resizeTimer: null,
        currentIsSP: void 0,
        assetState: {
            loaded: !1,
            loading: !1,
            queue: []
        },
        isFadePending: !1,
        destroyTimer: null,
        hiddenCards: null
    };

    function hasJquery() {
        return typeof window.jQuery !== "undefined" && window.jQuery;
    }

    function ensureDomReferences() {
        if (talkMasonry.grid && talkMasonry.grid.length) {
            return;
        }
        cacheDom();
    }

    function getCardNodeList() {
        ensureDomReferences();
        if (talkMasonry.grid && talkMasonry.grid.length && talkMasonry.grid[0]) {
            return talkMasonry.grid[0].querySelectorAll(".talk__grid");
        }
        var container = document.getElementById("talk__container");
        return container ? container.querySelectorAll(".talk__grid") : [];
    }

    function ensureCardTransition(el) {
        if (!el || !el.style) {
            return;
        }
        if (!el.style.transition) {
            el.style.transition = "opacity 0.5s ease";
            return;
        }
        if (el.style.transition.indexOf("opacity") === -1) {
            el.style.transition += ",opacity 0.3s ease";
        }
    }

    function setCardHidden(el) {
        if (!el || !el.style) {
            return;
        }
        console.log('[HIDE] Setting card to opacity: 0, current:', el.style.opacity);
        ensureCardTransition(el);
        el.style.opacity = "0";
        // el.style.visibility = "hidden";
        el.style.pointerEvents = "none";
    }

    function setCardVisible(el) {
        if (!el || !el.style) {
            return;
        }
        el.style.visibility = "visible";
        el.style.opacity = "1";
        el.style.pointerEvents = "";
    }

    function hideAllCards() {
        console.log('[2.1] hideAllCards() - hiding', getCardNodeList().length, 'cards');
        var cards = getCardNodeList();
        if (!cards || cards.length === 0) {
            talkMasonry.isFadePending = !1;
            talkMasonry.hiddenCards = null;
            return;
        }
        talkMasonry.isFadePending = !0;
        console.log('[2.2] hideAllCards() - isFadePending set to true');
        talkMasonry.hiddenCards = Array.prototype.slice.call(cards);
        talkMasonry.hiddenCards.forEach(setCardHidden);
    }

    function applyPendingStateToElements(elements) {
        if (!elements || !elements.length) {
            return;
        }
        // 新しいカードが追加されたので、フェードイン待ち状態にする
        console.log('[6] applyPendingStateToElements receiving', elements.length, 'elements');
        talkMasonry.isFadePending = !0;
        console.log('[6.1] applyPendingStateToElements - isFadePending set to true');
        if (!talkMasonry.hiddenCards) {
            talkMasonry.hiddenCards = [];
        }
        for (var i = 0; i < elements.length; i++) {
            var el = elements[i];
            if (!el) {
                continue;
            }
            if (talkMasonry.hiddenCards.indexOf(el) === -1) {
                talkMasonry.hiddenCards.push(el);
            }
            setCardHidden(el);
        }
    }

    function fadeInAllCards() {
        console.log('[11.1] fadeInAllCards() - isFadePending:', talkMasonry.isFadePending);
        console.trace('[11.1] fadeInAllCards() called from:');
        if (!talkMasonry.isFadePending) {
            return;
        }
        var cards = talkMasonry.hiddenCards && talkMasonry.hiddenCards.length ? talkMasonry.hiddenCards.slice() : Array.prototype.slice.call(getCardNodeList() || []);
        console.log('[11.2] Fading in', cards.length, 'cards');

        // フラグクリアを遅延させて、トランジション中の他のレイアウトイベントによる干渉を防ぐ
        // talkMasonry.isFadePending = !1; 
        // talkMasonry.hiddenCards = null;

        if (!cards || cards.length === 0) {
            talkMasonry.isFadePending = !1;
            talkMasonry.hiddenCards = null;
            return;
        }
        window.requestAnimationFrame(function () {
            console.log('[11.3] Applying opacity: 1 to cards');
            for (var i = 0; i < cards.length; i++) {
                setCardVisible(cards[i]);
            }
            console.log('[12] ✅ Fade-in complete (transition started)');

            // トランジション完了（約500ms）後にフラグをクリア
            setTimeout(function () {
                console.log('[13] Clearing isFadePending flag');
                talkMasonry.isFadePending = !1;
                talkMasonry.hiddenCards = null;
            }, 600);
        });
    }

    function enqueueCallback(callback) {
        talkMasonry.assetState.queue.push(callback);
    }

    function flushCallbacks() {
        var queue = talkMasonry.assetState.queue.slice();
        talkMasonry.assetState.queue.length = 0;
        while (queue.length) {
            var cb = queue.shift();
            cb && cb();
        }
    }

    function isAssetsReady() {
        return typeof window.Masonry === "function" && typeof window.imagesLoaded === "function";
    }

    function loadScriptChain(sources, index, done) {
        if (index >= sources.length) {
            done();
            return;
        }
        var item = sources[index];
        if (item.check()) {
            loadScriptChain(sources, index + 1, done);
            return;
        }
        var script = document.createElement("script");
        script.src = item.src;
        script.async = !0;
        script.onload = function () {
            loadScriptChain(sources, index + 1, done);
        };
        script.onerror = function () {
            console.error("Talk Masonry: failed to load", item.src);
            loadScriptChain(sources, index + 1, done);
        };
        (document.head || document.body).appendChild(script);
    }

    function ensureMasonryAssets(callback) {
        if (isAssetsReady()) {
            talkMasonry.assetState.loaded = !0;
            callback();
            return;
        }

        enqueueCallback(callback);

        if (talkMasonry.assetState.loading) {
            return;
        }

        talkMasonry.assetState.loading = !0;

        var scripts = [];
        if (!hasJquery()) {
            scripts.push({
                src: "https://code.jquery.com/jquery-3.7.1.min.js",
                check: hasJquery
            });
        }
        scripts.push({
            src: "https://unpkg.com/imagesloaded@5/imagesloaded.pkgd.min.js",
            check: function () {
                return typeof window.imagesLoaded === "function";
            }
        });
        scripts.push({
            src: "https://unpkg.com/masonry-layout@4/dist/masonry.pkgd.min.js",
            check: function () {
                return typeof window.Masonry === "function";
            }
        });

        loadScriptChain(scripts, 0, function () {
            talkMasonry.assetState.loaded = isAssetsReady();
            talkMasonry.assetState.loading = !1;
            flushCallbacks();
        });
    }

    function cacheDom() {
        if (!hasJquery()) {
            return !1;
        }
        var $ = window.jQuery;
        talkMasonry.grid = $('#talk__container');
        talkMasonry.wrapper = $('.masonry-wrapper');
        talkMasonry.moreButton = $('#talk__btn_more');
        if (!(talkMasonry.grid && talkMasonry.grid.length)) {
            talkMasonry.wrapper = null;
            talkMasonry.moreButton = null;
            return !1;
        }
        return !0;
    }

    function getCurrentWidth() {
        ensureDomReferences();
        if (talkMasonry.wrapper && talkMasonry.wrapper.length && talkMasonry.wrapper[0]) {
            return talkMasonry.wrapper[0].clientWidth || parseInt(talkMasonry.wrapper.width(), 10) || 0;
        }
        if (talkMasonry.grid && talkMasonry.grid.length && talkMasonry.grid[0]) {
            return talkMasonry.grid[0].clientWidth;
        }
        return window.innerWidth || document.documentElement.clientWidth || 0;
    }

    function getMasonryConfig() {
        var containerWidth = getCurrentWidth();
        var isSP = containerWidth && containerWidth <= 750;
        talkMasonry.currentIsSP = isSP;
        if (isSP) {
            return {
                itemSelector: '.talk__grid',
                columnWidth: 670,
                gutter: 0,
                fitWidth: !0,
                transitionDuration: 0,
                percentPosition: !1
            };
        }
        return {
            itemSelector: '.talk__grid',
            columnWidth: 420,
            gutter: 40,
            fitWidth: !0,
            transitionDuration: 0,
            percentPosition: !1
        };
    }

    function applyLayout() {
        console.log('🔄 [CACHE CHECK] applyLayout v2.0 - isFadePending check ENABLED');
        if (!talkMasonry.grid || !talkMasonry.grid.length || !talkMasonry.wrapper || !talkMasonry.wrapper.length) {
            return;
        }
        var rect = talkMasonry.grid[0].getBoundingClientRect();
        var height = rect.height;
        talkMasonry.wrapper.css({
            height: height + 'px',
            minHeight: height + 'px'
        });
        if (talkMasonry.moreButton && talkMasonry.moreButton.length) {
            // [FIX] メインロジック（TalkScene）での制御を優先するため、ここでは強制表示しない
            // talkMasonry.moreButton.css({ display: 'block' }).addClass('show');
        }
        // MOREボタンロード中（isFadePending=true）の場合は、apiLoadComp側で厳密な高さ計算とフェードイン制御を行うため
        // ここ（汎用レイアウトハンドラ）では一切の処理（高さ設定含む）をスキップする
        console.log('🔍 [applyLayout] Checking isFadePending:', talkMasonry.isFadePending);
        if (talkMasonry.isFadePending) {
            console.log('⏭️ [applyLayout] isFadePending is true, SKIPPING applyLayout entirely (height set & fadeIn)');
            return;
        }

        console.log('✅ [applyLayout] isFadePending is false, proceeding with layout');
        fadeInAllCards();
    }

    function destroyInstance(keepWrapperSize) {
        if (talkMasonry.instance && talkMasonry.layoutHandler) {
            talkMasonry.instance.off('layoutComplete', talkMasonry.layoutHandler);
        }
        if (talkMasonry.instance) {
            talkMasonry.instance.destroy();
        }
        talkMasonry.instance = null;
        talkMasonry.layoutHandler = null;
        if (talkMasonry.wrapper && talkMasonry.wrapper.length && !keepWrapperSize) {
            talkMasonry.wrapper.css({
                height: '',
                minHeight: ''
            });
        }
        if (talkMasonry.moreButton && talkMasonry.moreButton.length && !keepWrapperSize) {
            talkMasonry.moreButton.removeClass('show').css({
                display: ''
            });
        }
    }

    function startLayout() {
        var config = getMasonryConfig();
        talkMasonry.instance = new window.Masonry('#talk__container', config);
        window.talkMasonryInstance = talkMasonry.instance;
        talkMasonry.layoutHandler = function () {
            applyLayout();
        };
        talkMasonry.instance.on('layoutComplete', talkMasonry.layoutHandler);
        talkMasonry.instance.layout();
        setTimeout(applyLayout, 150);
    }

    function initMasonryInternal() {
        clearDestroyTimer();
        if (!cacheDom()) {
            return;
        }
        destroyInstance(!0);
        talkMasonry.hiddenCards = null;
        if (talkMasonry.moreButton && talkMasonry.moreButton.length) {
            // [FIX] TalkSceneでの制御を優先するため、初期化時の強制非表示を無効化
            // talkMasonry.moreButton.removeClass('show').css({ display: 'none' });
        }
        if (typeof talkMasonry.grid.imagesLoaded === 'function') {
            talkMasonry.grid.imagesLoaded(function () {
                startLayout();
            });
        } else if (typeof window.imagesLoaded === 'function') {
            window.imagesLoaded(talkMasonry.grid[0], function () {
                startLayout();
            });
        } else {
            startLayout();
        }
    }

    function initMasonry() {
        if (!hasJquery()) {
            ensureMasonryAssets(function () {
                cacheDom() && initMasonryInternal();
            });
            return;
        }
        ensureMasonryAssets(function () {
            initMasonryInternal();
        });
    }

    window.applyTalkMasonryLayout = applyLayout;
    window.initMasonryNow = initMasonry;

    function clearDestroyTimer() {
        if (talkMasonry.destroyTimer) {
            clearTimeout(talkMasonry.destroyTimer);
            talkMasonry.destroyTimer = null;
        }
    }

    function destroyMasonryNow() {
        talkMasonry.destroyTimer = null;
        destroyInstance(!0);
        talkMasonry.grid = null;
        talkMasonry.wrapper = null;
        talkMasonry.moreButton = null;
        talkMasonry.isFadePending = !1;
        console.log('[DESTROY] destroyMasonryNow - isFadePending set to false');
        talkMasonry.hiddenCards = null;
    }

    window.destroyTalkMasonry = function () {
        clearDestroyTimer();
        destroyMasonryNow();
    };

    window.scheduleTalkMasonryDestroy = function (delay) {
        clearDestroyTimer();
        var ms = typeof delay === 'number' ? delay : 0;
        talkMasonry.destroyTimer = setTimeout(function () {
            talkMasonry.destroyTimer = null;
            destroyMasonryNow();
        }, ms);
    };

    window.cancelTalkMasonryDestroy = function () {
        clearDestroyTimer();
    };

    function handleResize() {
        if (!talkMasonry.grid) {
            return;
        }
        clearTimeout(talkMasonry.resizeTimer);
        talkMasonry.resizeTimer = setTimeout(function () {
            var containerWidth = getCurrentWidth();
            var isSP = containerWidth && containerWidth <= 750;
            if (typeof talkMasonry.currentIsSP === 'undefined') {
                talkMasonry.currentIsSP = isSP;
            }
            if (talkMasonry.currentIsSP !== isSP) {
                talkMasonry.currentIsSP = isSP;
                initMasonry();
            } else if (talkMasonry.instance) {
                talkMasonry.instance.layout();
            }
        }, 250);
    }

    window.addEventListener('load', function () {
        setTimeout(initMasonry, 500);
    });

    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            setTimeout(initMasonry, 100);
        }
    });

    document.addEventListener('visibilitychange', function () {
        if (!document.hidden && talkMasonry.instance) {
            setTimeout(function () {
                talkMasonry.instance && talkMasonry.instance.layout();
            }, 100);
        }
    });

    window.addEventListener('resize', handleResize);

    if (hasJquery()) {
        window.jQuery(function () {
            cacheDom();
        });
    }

    window.talkMasonryHideAllCards = hideAllCards;
    window.talkMasonryFadeInCards = fadeInAllCards;
    window.talkMasonryPrepareNewCards = applyPendingStateToElements;

    // フェードアウト完了を待つ関数（transitionendイベントベース）
    window.waitForTalkMasonryFadeOut = function () {
        console.log('[3] waitForTalkMasonryFadeOut() - waiting for transitionend');
        return new Promise(function (resolve) {
            if (!talkMasonry.isFadePending) {
                console.log('[3.1] No fade pending, resolving immediately');
                resolve();
                return;
            }

            var cards = talkMasonry.hiddenCards || [];
            if (cards.length === 0) {
                console.log('[3.2] No hidden cards, resolving immediately');
                resolve();
                return;
            }

            function onTransitionEnd(e) {
                // opacityのtransitionのみを検知
                if (e.propertyName === 'opacity') {
                    console.log('[3.3] transitionend fired for opacity');
                    resolve();
                }
            }

            // 最初のカードのtransitionendのみを監視
            // 全カードは同時にtransitionするため、1枚の完了で全体の完了とみなす
            var firstCard = cards[0];
            if (firstCard) {
                console.log('[3.4] Listening for transitionend on first card');
                firstCard.addEventListener('transitionend', onTransitionEnd, {
                    once: true
                });
            } else {
                // カードがない場合は即座に解決
                console.log('[3.5] No first card, resolving immediately');
                resolve();
            }
        });
    };
})(window);


// ============================================
// TalkScene - トークページシーン
// ============================================
/**
 * GNS.TalkScene
 * 
 * トーク一覧ページ（/talk/）の処理
 * 
 * 機能:
 * - トーク記事一覧表示（グリッドレイアウト）
 * - ページング（More読み込み）
 * - 言語切り替えに応じたグリッド再計算★
 * 
 * 主要メソッド:
 * - load(): API からトークデータ取得
 * - addLoadList(element): グリッドアイテム追加
 * - resizeGridItem(item): グリッドアイテムのサイズ調整
 * - resizeGridItem(item): グリッドアイテムのサイズ調整
 */
GNS.TalkScene = function (a) {
    var b = a.create(a.AbstractScene);
    b.init = function (c) {
        b._super.init.apply(this, [c]), this.page = 1, this.total_page = 1, this.isLoading = !1, this.needsMasonryLayout = !1, this.checkItems = [],
            this.lastScrollCheckTime = 0, this.scrollCheckDebounceMs = 2000,
            this.container = new a.DisplayObject("talk__container"), this.aboutGrid = new a.DisplayObject(
                "talk__about__grid"), this.btnMore = new a.DisplayObject("talk__btn_more"), this.btnMoreShadow = new a
                    .DisplayObject("column__btn_more__shadow"), this.touchController = new a.TouchActionController(this.element),
            this.touchController.isPreventDefault = !1, this.btnMore.addEvent("click", this.loadMore)
    }, b.load = function () {
        console.log("TalkScene::load");
        this.addLoadList(this.aboutGrid.element);

        // 初回ロード時にPHP生成済みのアイテムがあるかチェック
        // talk__about__gridを除外（これもtalk__gridクラスを持っているため）
        var existingItems = this.container.element.querySelectorAll('.talk__grid:not(#talk__about__grid)');
        if (this.page === 1 && existingItems.length > 0) {
            // data属性からtotal_pageを取得
            var totalPageAttr = this.container.element.getAttribute('data-total-page');
            this.total_page = totalPageAttr ? parseInt(totalPageAttr) : 1;

            // 既存アイテムを登録
            for (var i = 0; i < existingItems.length; i++) {
                this.addLoadList(existingItems[i]);
                this.addSceneEventIn(existingItems[i]);
            }

            // ボタン要素の確実な取得
            var btnEl = this.btnMore && this.btnMore.element ? this.btnMore.element : document.getElementById('talk__btn_more');

            if (this.page < this.total_page) {
                this.btnMore.addClass("show");
                if (btnEl) {
                    btnEl.style.display = 'block';
                    btnEl.style.removeProperty('display');
                }
            } else {
                this.btnMore.removeClass("show");
                if (btnEl) {
                    btnEl.style.display = 'none';
                    btnEl.style.setProperty('display', 'none', 'important');
                }
            }
            this._loadComplete();
        } else {
            // APIから取得
            this.isLoading = !0, a.APITalk.dispatcher.addEventListener(a.Event.COMPLETE, this.apiLoadComp), a.APITalk.request(this.page)
        }
    }, b._bind.apiLoadComp = function (b) {
        if (!b || !b.params) {
            return;
        }
        a.APITalk.dispatcher.removeEventListener(a.Event.COMPLETE, this.apiLoadComp);

        if (b.params.html) {
            var c = b.params.total_page;
            this.total_page = c;
            var newCards = [];
            console.log('[5.1] Received HTML from server, processing new cards');

            var tempDiv = document.createElement("div");
            tempDiv.innerHTML = b.params.html;
            var children = Array.prototype.slice.call(tempDiv.children);

            for (var f = 0; f < children.length; f++) {
                var h = children[f];
                // 新しいカードは opacity: 0 で作成（レイアウト後にフェードイン）
                h.style.opacity = "0";
                h.style.transition = "opacity 0.5s ease";

                this.addLoadList(h);
                this.container.element.appendChild(h);
                this.addSceneEventIn(h);
                newCards.push(h);
            }
            console.log('[5.2] New cards added to DOM');
            if (newCards.length && typeof window.talkMasonryPrepareNewCards === "function") {
                console.log('[6] Calling talkMasonryPrepareNewCards()');
                window.talkMasonryPrepareNewCards(newCards);
            }

            // 読み込み数が設定数(posts_per_page)より少なければ、最終ページとみなしてボタンを消す
            var perPage = parseInt(b.params.posts_per_page || 6, 10);
            var loadedCount = newCards.length;

            console.log('[MoreButton] loadedCount:', loadedCount, 'perPage:', perPage, 'page:', this.page, 'total:', this.total_page);

            // ボタン要素の確実な取得
            var btnEl = this.btnMore && this.btnMore.element ? this.btnMore.element : document.getElementById('talk__btn_more');
            console.log('[MoreButton] Target element:', btnEl);

            if (loadedCount < perPage) {
                console.log('[MoreButton] Hiding button (Under limit)');
                this.btnMore.removeClass("show");
                if (btnEl) {
                    btnEl.style.display = 'none';
                    // 強制的にスタイルを適用（!important対策も含めて検討するが、まずはinlineで）
                    btnEl.style.setProperty('display', 'none', 'important');
                }
            } else {
                if (this.page < this.total_page) {
                    this.btnMore.addClass("show");
                    if (btnEl) {
                        btnEl.style.display = 'block';
                        btnEl.style.removeProperty('display'); // inline styleを削除してクラスに任せる、もしくはblock強制
                    }
                } else {
                    console.log('[MoreButton] Hiding button (End of pages)');
                    this.btnMore.removeClass("show");
                    if (btnEl) {
                        btnEl.style.display = 'none';
                        btnEl.style.setProperty('display', 'none', 'important');
                    }
                }
            }

            // Masonry.jsのレイアウトを再計算（新しいアイテム追加後）
            if (typeof window.talkMasonryInstance !== 'undefined' && window.talkMasonryInstance) {
                var $grid = jQuery('#talk__container');
                var $wrapper = jQuery('.masonry-wrapper');
                var self = this;

                // 新しく追加されたアイテムの画像読み込みを待つ
                if (typeof imagesLoaded !== 'undefined') {
                    console.log('[7] Waiting for NEW images to load (' + newCards.length + ' items)');
                    imagesLoaded(newCards, function () {
                        console.log('[8] Images loaded, reloading Masonry items');
                        window.talkMasonryInstance.reloadItems();


                        // layoutCompleteイベントを一度だけ待つ
                        function onLayoutComplete() {
                            console.log('[10] layoutComplete event fired');
                            window.talkMasonryInstance.off('layoutComplete', onLayoutComplete);

                            // レイアウト完了後に高さ再計算とフェードイン
                            console.log('[10.0] Grid element:', $grid[0]);
                            console.log('[10.0] Grid display:', window.getComputedStyle($grid[0]).display);
                            console.log('[10.0] Grid visibility:', window.getComputedStyle($grid[0]).visibility);

                            // Masonryのアイテムから最大の高さを計算
                            var maxBottom = 0;
                            var items = window.talkMasonryInstance.items;
                            console.log('[10.0.1] Masonry items count:', items.length);

                            for (var i = 0; i < items.length; i++) {
                                var item = items[i];
                                if (item.position && item.size) {
                                    var bottom = item.position.y + item.size.height;
                                    if (bottom > maxBottom) {
                                        maxBottom = bottom;
                                    }
                                }
                            }

                            var correctHeight = maxBottom > 0 ? maxBottom : $grid[0].offsetHeight;
                            console.log('[10.1] Calculated height from Masonry:', maxBottom, 'fallback:', $grid[0].offsetHeight, 'final:', correctHeight);
                            console.log('[10.2] Current wrapper height:', $wrapper.css('height'));

                            $wrapper.css({
                                'height': correctHeight + 'px',
                                'min-height': correctHeight + 'px'
                            });
                            console.log('[10.3] Wrapper height set to:', correctHeight + 'px');

                            // フェードイン (描画ズレ防止のため、レイアウト確定・描画完了まで待つ)
                            window.requestAnimationFrame(function () {
                                window.requestAnimationFrame(function () {
                                    console.log('[11] Starting fade-in (delayed)');
                                    if (typeof window.talkMasonryFadeInCards === "function") {
                                        window.talkMasonryFadeInCards();
                                    }
                                });
                            });
                        }

                        console.log('[9] Calling Masonry layout()');
                        window.talkMasonryInstance.on('layoutComplete', onLayoutComplete);
                        window.talkMasonryInstance.layout();
                    });
                } else {
                    // imagesLoadedが利用できない場合は直接レイアウト
                    window.talkMasonryInstance.reloadItems();

                    // layoutCompleteイベントを一度だけ待つ
                    function onLayoutComplete() {
                        window.talkMasonryInstance.off('layoutComplete', onLayoutComplete);

                        // レイアウト完了後に高さ再計算とフェードイン
                        var gridRect = $grid[0].getBoundingClientRect();
                        var correctHeight = gridRect.height;

                        $wrapper.css({
                            'height': correctHeight + 'px',
                            'min-height': correctHeight + 'px'
                        });

                        // フェードイン
                        if (typeof window.talkMasonryFadeInCards === "function") {
                            window.talkMasonryFadeInCards();
                        }
                    }

                    window.talkMasonryInstance.on('layoutComplete', onLayoutComplete);
                    window.talkMasonryInstance.layout();
                }
            } else {
                console.log('[9-ELSE] Masonry instance is missing!');
            }
        } else {
            console.log('[5-ELSE] API response is invalid or empty:', b);
            if (typeof window.talkMasonryFadeInCards === "function") {
                window.talkMasonryFadeInCards();
            }
        }
        this._loadComplete()
    }, b._bind._loadComplete = function (a) {
        this.isLoading = !1, b._super.load.call(this);

        // Masonryレイアウトの再初期化フラグをセット
        // 追加読み込み(page > 1)の時は apiLoadComp 内で個別に対応するため、全初期化(initMasonryNow)は行わない
        // これを行ってしまうと talkMasonry.hiddenCards がクリアされ、フェードイン対象が全カードになってしまう
        if (typeof window.initMasonryNow === 'function' && this.page === 1) {
            this.needsMasonryLayout = !0;
            if (this.isShow) {
                window.initMasonryNow();
                this.needsMasonryLayout = !1;
            }
        }
    }, b.showHandler = function (b) {
        if (typeof window.cancelTalkMasonryDestroy === 'function') {
            window.cancelTalkMasonryDestroy();
        }
        if (typeof window.initMasonryNow === 'function') {
            var self = this;
            setTimeout(function () {
                if (self.needsMasonryLayout) {
                    window.initMasonryNow();
                    self.needsMasonryLayout = !1;
                }
            }, 100);
        }
        // スクロール検知イベントの登録（Windows対応）
        this.moreProgress = 0;
        this.touchController.addEventListener(a.TouchActionEvent.TOUCH_1_MOVE, this.dragging);
        a.DOM.addEvent(window, "scroll", this.scrollCheck);
        if ("undefined" != typeof this.element.onmousewheel) {
            this.element.onmousewheel = this.onMouseWheelHandler;
        } else if (this.element.addEventListener) {
            this.element.addEventListener("DOMMouseScroll", this.onMouseWheelHandler, !1);
        }
    }, b.hideHandler = function (b) {
        if (typeof window.scheduleTalkMasonryDestroy === 'function') {
            window.scheduleTalkMasonryDestroy(600);
        } else if (typeof window.destroyTalkMasonry === 'function') {
            setTimeout(window.destroyTalkMasonry, 600);
        }
        this.touchController.removeEventListener(a.TouchActionEvent.TOUCH_1_MOVE, this.dragging), a.DOM.removeEvent(
            window, "scroll", this.scrollCheck), "undefined" != typeof this.element.onmousewheel ? this.element
                .onmousewheel = this.onMouseWheelHandler : this.element.addEventListener && this.element.addEventListener(
                    "DOMMouseScroll", this.onMouseWheelHandler, !1)
    }, b.resetHandler = function (a) {
        if (typeof window.scheduleTalkMasonryDestroy === 'function') {
            window.scheduleTalkMasonryDestroy(0);
        } else if (typeof window.destroyTalkMasonry === 'function') {
            window.destroyTalkMasonry();
        }
    }, b._bind.loadMore = function (b) {
        if (b) {
            if (b.preventDefault) b.preventDefault();
            if (b.stopPropagation) b.stopPropagation();
        }
        if (this.isLoading || this.page >= this.total_page) {
            return;
        }

        var self = this;

        // 既存カードはフェードアウトせず、そのままロードして追加分だけフェードインする
        console.log('[2] Skipping fade-out, directly starting API call');
        this.page++;
        this.load();
        this.load();
    }, b._bind.scrollCheck = function () {
        // デバウンス：最後のscrollCheckから指定時間（デフォルト2秒）経過していない場合は早期リターン
        var currentTime = Date.now();
        if (currentTime - this.lastScrollCheckTime < this.scrollCheckDebounceMs) {
            return;
        }

        // 既に読み込み処理が開始されている場合は早期リターン（重複防止）
        if (this.moreProgress > 0) {
            return;
        }
        if (!this.isLoading && this.page != this.total_page) {
            var b = a.DOM.getPageSize();
            // 底に到達する100px前から検知（ブラウザ差・丸め誤差対応）
            var threshold = 100;
            var isNearBottom = b.scrollY + b.displayHeight >= b.stageHeight - threshold;
            if (isNearBottom) {
                // 最後のscrollCheck時刻を更新
                this.lastScrollCheckTime = currentTime;
                // スクロール検知時も即座にloadMoreを実行（MOREボタンと同じ動作）
                this.loadMore();
            }
        }
    }, b._bind.onMouseWheelHandler = function (a) {
        if (!a) var a = window.event;
        var b = a.detail ? -a.detail / 3 : a.wheelDelta / 120,
            c = -b;
        c > 0 && this.scrollCheck()
    }, b._bind.dragging = function (a) {
        var b = -(this.touchController.touch0CurrentY - this.touchController.touch0PrevY);
        b > 20 && this.scrollCheck()
    };
    var c = null,
        d = !1;
    return b._bind.startMoreTimer = function () {
        d || (d = !0, c = setInterval(this.moreTimeUpdate))
    }, b._bind.moreTimeUpdate = function () {
        this.moreProgress *= .995;
        var b = a.Animate.easeOutQuart(Math.min(this.moreProgress, 15) / 15, 0, 100, 1);
        this.btnMoreShadow.element.style.height = b + "%", this.moreProgress < .5 ? (this.moreProgress = 0,
            clearInterval(c), d = !1, this.btnMoreShadow.element.style.height = "0%") : this.moreProgress > 15 && (this
                .moreProgress = 0, clearInterval(c), d = !1, this.btnMoreShadow.element.style.height = "0%", this.loadMore()
            )
    }, b._self
}(GNS);
